module.exports = __webpack_public_path__ + "static/media/WhatsApp.a6f92e44.svg";